import { isLanguageAvailable } from '@/utils/cmsRoutesMap/nonTranslatedPagesMap'
import { findRouteByUrl, getRouteLanguages } from '@/utils/utils'

const isValidUrl = (url?: string) => {
  try {
    return url ? Boolean(new URL(url)) : false
  } catch (e) {
    return false
  }
}

const addHreflangLink = (hreflang: string, url: string) => {
  const linkElement = document.createElement('link')
  linkElement.setAttribute('rel', 'alternate')
  linkElement.setAttribute('hreflang', hreflang)
  linkElement.setAttribute('href', url)
  document.head.appendChild(linkElement)
}


export const useAlternateHreflang = (
    alternateUrls: Record<string, string | undefined>,
    xDefault = 'en'
) => {
  const languages = ['en', 'pt', 'th', 'es', 'ko', 'zh-hans', 'zh-hant', 'jp']

  languages.forEach((lang) => {
    const url = alternateUrls[lang]
    if (url && !url.includes('/404/') && isLanguageAvailable(url, lang)) {
      addHreflangLink(lang, url)
    }
  })
  addHreflangLink('x-default', alternateUrls[xDefault] as string)
}

export const backToMain = () =>
  new Promise((resolve) => {
    setTimeout(resolve, 0)
  })

export const useHreflang = async () => {
  const route = findRouteByUrl(window.location.pathname)

  if (!route || route.path === '/prime/') return
  const alternateUrls = getRouteLanguages(route.name, route.params)
  const queue = [() => useAlternateHreflang(alternateUrls)]

  while (queue.length) {
    const task = queue.pop()
    if (!task) continue
    await backToMain()
    task()
  }
}
